import { Component } from '@angular/core';
import { IonicPage, LoadingController, NavController, NavParams, ToastController } from 'ionic-angular';

import { globalDefines } from '../../app/app.constants';
import { AreaProvider } from '../../providers/area/area';
import { ReportProvider } from '../../providers/report/report';


@IonicPage()
@Component({
  selector: 'page-report-month',
  templateUrl: 'report-month.html',
})
export class ReportMonthPage {

  areas;
  selectedAreas = [];

  beginMonth;
  endMonth;

  constructor(
    public loadingCtrl: LoadingController,
    public navCtrl: NavController,
    public navParams: NavParams,
    public toastCtrl: ToastController,
    public areaProvider: AreaProvider,
    public reportProvider: ReportProvider,
  ) {
    this.areas = this.areaProvider.getAllVisibleAreas();
  }

  generate() {
    if (this.beginMonth && this.endMonth && this.selectedAreas.length > 0) {

      // Mostrar loading
      let loading = this.loadingCtrl.create({
        content: 'Generando PDF...'
      });

      loading.present();
      
      this.reportProvider.monthReport(this.selectedAreas, this.beginMonth, this.endMonth)
        .then(() => loading.dismiss())
        .catch(error => loading.dismiss())
    }
    else this.showMessage('Introduzca todos los datos.');
  }

  private showMessage(message: string) {
    this.toastCtrl.create({message: message, duration: globalDefines.defaultToastDuration}).present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/report-month/report-month.ts